'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retry = retry;
exports.isInt = isInt;
// Promise retry
function retry(fn) {
  var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
  var code = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  return new Promise(function (resolve, reject) {
    fn.then(resolve).catch(reject);
  }).catch(function (reason) {
    times -= 1;
    if (times > 0 && (code === '' || code === (reason || {}).status)) {
      return retry(fn, times, code);
    } else {
      return Promise.reject(reason);
    }
  });
}

// IsInt() since Number.isInteger() is not supported by IE11
function isInt(value) {
  if (Number.isInteger) {
    return Number.isInteger(value);
  } else {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  }
}